import src from "IMAGE";
export default { src, width: 109, height: 18, blurWidth: 0, blurHeight: 0};
